export const PUBLIC_TOKEN_DIGITS = 6;

export const expiredLinkMessage = {
  title: 'Este termo expirou.',
  message: 'Solicite um novo termo ao seu(a) assessor(a) para continuar.',
};
